import Markdown, { Components } from 'react-markdown';

import { openExternalLink } from '../../../utils/telegramLink';

/**
 * Оформление Markdown из админки под шрифты приложения. Плагина typography в
 * проекте нет, поэтому каждый тег — свой класс. Сырой HTML react-markdown не
 * исполняет: в тексте он покажется как текст.
 */
const components: Components = {
  p: ({ children }) => <p>{children}</p>,
  h1: ({ children }) => (
    <p className="text-body-base-semibold text-text-primary">{children}</p>
  ),
  h2: ({ children }) => (
    <p className="text-body-base-semibold text-text-primary">{children}</p>
  ),
  h3: ({ children }) => (
    <p className="text-body-sm-semibold text-text-primary">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold text-text-primary">{children}</strong>
  ),
  ul: ({ children }) => (
    <ul className="list-disc space-y-1 pl-5">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal space-y-1 pl-5">{children}</ol>
  ),
  // Ссылки — через Telegram: обычный переход увёл бы из мини-аппа.
  a: ({ href, children }) => (
    <a
      href={href}
      className="text-brand-green underline"
      onClick={event => {
        if (!href) return;
        event.preventDefault();
        openExternalLink(href);
      }}
    >
      {children}
    </a>
  ),
  hr: () => <hr className="border-fill-background" />,
};

export const PromoMarkdown = ({ children }: { children: string }) => (
  <div className="flex flex-col space-y-2 break-words text-body-sm-regular text-text-secondary">
    <Markdown components={components}>{children}</Markdown>
  </div>
);
